module.exports = __webpack_public_path__ + "img/snow-1.593d0a66.svg";